module.exports = __webpack_public_path__ + "static/media/userarea-app-image.27783142.png";